import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown, Save } from "lucide-react";
import { accApi, accErr, money } from "./AccountsPanel";

export { ProcurementTab } from "./ProcurementTab";

export const GstTab = ({ company }) => {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => {
    const [y, m] = month.split("-").map(Number);
    const last = new Date(y, m, 0).getDate();
    accApi(`/reports/summary?company_id=${company.id}&date_from=${month}-01&date_to=${month}-${last}`).then(setD).catch(accErr);
  }, [company.id, month]);
  const gstr1 = () => accApi(`/gstr1?company_id=${company.id}&month=${month}`).then(j => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([JSON.stringify(j, null, 2)], { type: "application/json" }));
    a.download = `GSTR1_${company.gstin || "company"}_${j.fp}.json`; a.click();
    toast.success("GSTR-1 JSON downloaded — upload it in the GST offline tool / portal");
  }).catch(accErr);
  const row = (l, b) => <tr className="border-t"><td className="px-3 py-2">{l}</td>{["taxable", "igst", "cgst", "sgst"].map(k => <td key={k} className="px-3 py-2 text-right">{money(b[k])}</td>)}</tr>;
  return (
    <div className="space-y-3" data-testid="acc-gst">
      <div className="flex flex-wrap items-center gap-2">
        <input type="month" value={month} onChange={e => setMonth(e.target.value)} className="rounded border px-2 py-1.5 text-sm" data-testid="acc-gst-month" />
        <button onClick={gstr1} className="inline-flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-semibold text-white" style={{ background: "var(--acc)" }} data-testid="acc-gstr1-btn"><FileDown className="w-4 h-4" /> GSTR-1 JSON</button>
        <span className="text-xs text-slate-500">E-way bill JSON: Sales tab → completed invoice → "E-way JSON".</span>
      </div>
      {d && <div className="overflow-x-auto rounded-xl border bg-white"><table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs text-slate-500"><tr><th className="px-3 py-2">{month}</th><th className="px-3 py-2 text-right">Taxable</th><th className="px-3 py-2 text-right">IGST</th><th className="px-3 py-2 text-right">CGST</th><th className="px-3 py-2 text-right">SGST</th></tr></thead>
        <tbody>{row("GST outward (sales)", d.gst_outward)}{row("GST inward (purchase ITC)", d.gst_inward)}
          <tr className="border-t bg-slate-50 font-bold"><td className="px-3 py-2">Net GST payable (3B)</td><td colSpan={4} className="px-3 py-2 text-right" data-testid="acc-gst-payable">{money(d.gst_payable)}</td></tr></tbody></table></div>}
    </div>
  );
};

const CF = [["gstin", "GSTIN"], ["state", "State"], ["state_code", "State code (e.g. 27)"], ["lut_no", "LUT number"], ["lut_valid_upto", "LUT valid up to"],
  ["invoice_prefix", "Sales invoice prefix (e.g. ESR/26-27/)"], ["purchase_prefix", "Purchase prefix"], ["fy_start", "FY start (YYYY-04-01)"],
  ["bank_name", "Bank"], ["bank_branch", "Bank branch"], ["bank_account", "Account no."], ["bank_ifsc", "IFSC"], ["email", "Email"], ["phone", "Phone"],
  ["drug_licence", "Drug licence no."], ["pre_carriage", "Pre-carriage by"], ["port_loading", "Port of loading"], ["terms", "Terms of payment"],
  ["max_parcels", "Max parcels per invoice"], ["declaration", "Invoice declaration"], ["theme_color", "Theme colour"]];

export const CompanySettings = ({ company, onSaved }) => {
  const [f, setF] = useState(company);
  useEffect(() => setF(company), [company]);
  const save = () => accApi(`/companies/${company.id}`, { method: "PUT", data: f }).then(() => { toast.success("Company details saved"); onSaved(); }).catch(accErr);
  return (
    <div className="space-y-3 rounded-xl border bg-white p-4" data-testid="acc-company-settings">
      <p className="text-xs text-slate-500">Extra accounting details, saved on the same company record used across the app (name and address stay in the Company panel).</p>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
        {CF.map(([k, l]) => (
          <label key={k} className="text-xs text-slate-600">{l}
            {k === "theme_color"
              ? <input type="color" value={f[k] || "#4f46e5"} onChange={e => setF({ ...f, [k]: e.target.value })} className="mt-0.5 block h-9 w-20 rounded border" data-testid={`acc-co-${k}`} />
              : <input value={f[k] || ""} onChange={e => setF({ ...f, [k]: e.target.value })} className="mt-0.5 w-full rounded border px-2 py-1.5 text-sm" data-testid={`acc-co-${k}`} />}
          </label>))}
      </div>
      <button onClick={save} className="inline-flex items-center gap-1 rounded-lg px-4 py-2 text-sm font-semibold text-white" style={{ background: "var(--acc)" }} data-testid="acc-co-save"><Save className="w-4 h-4" /> Save</button>
    </div>
  );
};
